import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Translation } from 'react-i18next';
import FormSelect from '../../components/FormSelect';
import FormRadio from '../../components/FormRadio';
import FormText from '../../components/FormText';
import FormDatePicker from '../../components/FormDatePicker';
import { object, string, arrayOf, any, func, bool } from 'prop-types';

import ErrorMsg from '../../../scenes/components/ErrorMsg';

const styles = (theme) => ({
  component: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  barLayout: {
    padding: theme.spacing(1),
  },
  group: {
    margin: theme.spacing(1, 0),
  },
});

const PersonalDetailsComponent = ({
  classes,
  surname,
  surnameError,
  isSurnameRequired,
  surnameChanged,
  firstName,
  firstNameError,
  isFirstNameRequired,
  firstNameChanged,
  dob,
  dobError,
  isDobRequired,
  dobChanged,
  countryOfBirth,
  countryOfBirthError,
  isCountryOfBirthRequired,
  countryOfBirthChanged,
  countries,
  cityOfBirth,
  cityOfBirthError,
  isCityOfBirthRequired,
  cityOfBirthChanged,
  gender,
  genderError,
  isGenderRequired,
  genderChanged,
  genders,
  relationshipStatus,
  relationshipStatusError,
  isRelationshipStatusRequired,
  relationshipStatusChanged,
  relationshipStatuses,
  occupations,
  occupation,
  occupationError,
  isOccupationRequired,
  occupationChanged,
  numberOfChildren,
  numberOfChildrenError,
  isNumberOfChildrenRequired,
  numberOfChildrenChanged,
  readOnly = false,
  error,
}) => (
  <Translation>
    {(t) => {
      return (
        <div>
          {!!error && <ErrorMsg error={error} />}
          <Typography
            className={classes.barLayout}
            style={{ color: '#ffffff', background: '#4CAF50' }}
            variant="subtitle1"
            align="left"
            gutterBottom
          >
            {t('personalDetails')}
          </Typography>
          <Grid
            container
            spacing={3}
            alignItems="flex-end"
            key="form-grid-container"
          >
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="surname"
                label={t('surname')}
                value={surname}
                onChange={surnameChanged}
                readOnly={readOnly}
                tooltip=""
                required={isSurnameRequired}
                error={surnameError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="first-given-names"
                label={t('firstGivenNames')}
                value={firstName}
                onChange={firstNameChanged}
                readOnly={readOnly}
                tooltip=""
                required={isFirstNameRequired}
                error={firstNameError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormDatePicker
                className={classes.component}
                label={t('dateBirth')}
                id="dob"
                value={dob}
                onChange={dobChanged}
                readOnly={readOnly}
                required={isDobRequired}
                error={dobError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormRadio
                className={classes.component}
                id="gender"
                label={t('gender')}
                value={gender}
                options={genders}
                onChange={genderChanged}
                readOnly={readOnly}
                required={isGenderRequired}
                error={genderError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="country-of-birth"
                label={t('countryBirth')}
                value={countryOfBirth}
                options={countries}
                onChange={countryOfBirthChanged}
                readOnly={readOnly}
                required={isCountryOfBirthRequired}
                error={countryOfBirthError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="city-of-birth"
                label={t('cityBirth')}
                value={cityOfBirth}
                onChange={cityOfBirthChanged}
                readOnly={readOnly}
                tooltip=""
                required={isCityOfBirthRequired}
                error={cityOfBirthError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="relationship-status"
                label={t('relantionship')}
                value={relationshipStatus}
                options={relationshipStatuses}
                onChange={relationshipStatusChanged}
                readOnly={readOnly}
                required={isRelationshipStatusRequired}
                error={relationshipStatusError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormSelect
                className={classes.component}
                id="occupation"
                label={t('occupation')}
                value={occupation}
                options={occupations}
                onChange={occupationChanged}
                readOnly={readOnly}
                required={isOccupationRequired}
                error={occupationError}
              />
            </Grid>
            <Grid item xs={6}>
              <FormText
                className={classes.component}
                id="number-of-children"
                type={'number'}
                label={t('numberChildren')}
                value={numberOfChildren}
                onChange={numberOfChildrenChanged}
                readOnly={readOnly}
                required={isNumberOfChildrenRequired}
                error={numberOfChildrenError}
              />
            </Grid>
          </Grid>
        </div>
      );
    }}
  </Translation>
);

PersonalDetailsComponent.propTypes = {
  classes: object.isRequired,
  surname: string,
  surnameError: string,
  isSurnameRequired: bool,
  surnameChanged: func.isRequired,
  firstName: string,
  firstNameError: string,
  isFirstNameRequired: bool,
  firstNameChanged: func.isRequired,
  dob: string,
  dobError: string,
  isDobRequired: bool,
  dobChanged: func.isRequired,
  countryOfBirth: string,
  countryOfBirthError: string,
  isCountryOfBirthRequired: bool,
  countryOfBirthChanged: func.isRequired,
  countries: arrayOf(any),
  cityOfBirth: string,
  cityOfBirthError: string,
  isCityOfBirthRequired: bool,
  cityOfBirthChanged: func.isRequired,
  gender: string,
  genderError: string,
  isGenderRequired: bool,
  genderChanged: func.isRequired,
  genders: arrayOf(any),
  relationshipStatus: string,
  relationshipStatusError: string,
  isRelationshipStatusRequired: bool,
  relationshipStatusChanged: func.isRequired,
  relationshipStatuses: arrayOf(any),
  occupations: arrayOf(any),
  occupation: string,
  occupationError: string,
  isOccupationRequired: bool,
  occupationChanged: func.isRequired,
  numberOfChildren: any,
  numberOfChildrenError: string,
  isNumberOfChildrenRequired: bool,
  numberOfChildrenChanged: func.isRequired,
  numberOfChildrenOptions: arrayOf(any),
};

export default withStyles(styles)(PersonalDetailsComponent);



// WEBPACK FOOTER //
// ./src/view/forms/Application/PersonalDetails/PersonalDetailsComponent.js